if($('.in-index').length){
    $(document).ready(function () {
        function mh_remove(){
            $('.blogFeed .news-item').not(":nth-child(-n+3)").remove();
            $('.news-item a.title').each(function(){
                $(this).closest('.news-item').find('.text').append('<span class="link"><a href="'+$(this).attr('href')+'">Přečíst celé</a></span>')
            })
        }
        if(sessionStorage.blogFeed) {
          $('.blogFeed').append(sessionStorage.blogFeed)
        } else {
          $.ajax({
            type: "GET",
            dataType: "html",
            timeout: 1e4,
            cache: !0,
            url: "/blog/",
            success: function(e) {
                var a = shoptet.common.createDocumentFromString(e),
                t = $(a).find("#newsWrapper").html();
                null !== t && ($(".blogFeed").html(t), mh_remove())
                sessionStorage.blogFeed = $(".blogFeed").html();
                }
            });
        }
    })
}

